export default __webpack_public_path__ + "static/media/neptun5.eda1bd3e.jpg";